'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * Sort by last name then by first name
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          */


var _lodash = require('lodash');

var separator = ' ';

var splitFullName = function splitFullName(fullName) {
  var nameArray = fullName.split(separator);
  return [nameArray.pop(), nameArray.join(separator)];
};

var byLastName = function byLastName(key) {
  return function (itemA, itemB) {
    var a = itemA[key];
    var b = itemB[key];

    if (a === b) return 0;

    if (!(0, _lodash.isString)(a)) return 1;
    if (!(0, _lodash.isString)(b)) return -1;

    var _splitFullName = splitFullName(a),
        _splitFullName2 = _slicedToArray(_splitFullName, 2),
        surnameA = _splitFullName2[0],
        nameA = _splitFullName2[1];

    var _splitFullName3 = splitFullName(b),
        _splitFullName4 = _slicedToArray(_splitFullName3, 2),
        surnameB = _splitFullName4[0],
        nameB = _splitFullName4[1];

    if (surnameA === surnameB) {
      return nameA > nameB ? 1 : -1;
    }

    return surnameA > surnameB ? 1 : -1;
  };
};

exports.default = byLastName;


//////////////////
// WEBPACK FOOTER
// ./~/rp-react-table/lib/RpTable/sorting/compareFns/byLastName.js
// module id = 2786
// module chunks = 0